import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faInfo,
    faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function Toaster({ toaster }) {
    if (!toaster) return null;

    useEffect(() => {
        if (toaster.type == "success") toast.success(toaster.message);
        if (toaster.type == "warning") toast.warning(toaster.message);
        if (toaster.type == "danger") toast.error(toaster.message);
    }, [toaster]);

    return (
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            icon={<ToasterIcon />}
            theme="colored"
        />
    );
}

function ToasterIcon({ type }) {
    if (type == "success") return <FontAwesomeIcon icon={faCheck} />;
    if (type == "warning")
        return <FontAwesomeIcon icon={faTriangleExclamation} />;
    if (type == "error")
        return <FontAwesomeIcon icon={faTriangleExclamation} />;
    if (type == "info") return <FontAwesomeIcon icon={faInfo} />;
}
